/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Status_PublishedInputs */

const en_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const es_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado`)
};

const fr_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publié`)
};

const de_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

const ja_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開済み`)
};

const zh_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发布`)
};

const ar_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منشور`)
};

const id_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterbitkan`)
};

const it_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicato`)
};

const ru_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовано`)
};

const pt_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicado`)
};

const ko_listing_status_published = /** @type {(inputs: Listing_Status_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게시됨`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Listing_Status_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_status_published = /** @type {((inputs?: Listing_Status_PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Status_PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_status_published(inputs)
	if (locale === "es") return es_listing_status_published(inputs)
	if (locale === "fr") return fr_listing_status_published(inputs)
	if (locale === "de") return de_listing_status_published(inputs)
	if (locale === "ja") return ja_listing_status_published(inputs)
	if (locale === "zh") return zh_listing_status_published(inputs)
	if (locale === "ar") return ar_listing_status_published(inputs)
	if (locale === "id") return id_listing_status_published(inputs)
	if (locale === "it") return it_listing_status_published(inputs)
	if (locale === "ru") return ru_listing_status_published(inputs)
	if (locale === "pt") return pt_listing_status_published(inputs)
	return ko_listing_status_published(inputs)
});